module.exports = __webpack_public_path__ + "images/batavus_small155351aa37f47755275b955b917e3ee9.png";